import { type ParsedUrlQuery, stringify } from 'querystring';
import { safeFormatClientDate } from 'shared/util/datetime-fns';
import { queryParamToString } from 'shared/util/query';
import { escapeQueryParams, queryParamToDate, queryParamToInteger, removeEmptyValues } from './queryParamConverters';
import type { HotelOffer, HotelProvider } from '@/interfaces';
import type { FromPage } from '@/interfaces/out';
import type { Props as OutPageProps } from '@/scenes/outPage/OutPage';

const queryParamsToState = (query: ParsedUrlQuery, deepLink: string, provider: HotelProvider): OutPageProps =>
    removeEmptyValues({
        provider,
        deepLink,
        price: queryParamToInteger(query.price),
        country: queryParamToString(query.country),
        place: queryParamToString(query.place),
        fromPage: queryParamToString(query.fromPage) as FromPage,
        checkInDate: queryParamToDate(query.checkInDate),
        checkOutDate: queryParamToDate(query.checkOutDate),
        hotel: queryParamToString(query.hotel),
    });

export const browserQueryParamsToOutPageProps = (query: ParsedUrlQuery, deepLink: string, provider: HotelProvider): OutPageProps =>
    queryParamsToState(escapeQueryParams(query), deepLink, provider);

export const offerToOutPageQueryParams = (offer: HotelOffer, fromPage: string): string =>
    stringify(
        removeEmptyValues({
            encryptedParams: offer.encryptedParams,
            price: offer.totalRate,
            country: offer.country,
            place: offer.place,
            fromPage,
            checkInDate: safeFormatClientDate(offer.checkInDate),
            checkOutDate: safeFormatClientDate(offer.checkOutDate),
            hotel: offer.hotelKey,
        }),
    );
